export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7036.4dae3068.jpg";